import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useCompareStore = defineStore('compare', () => {
  const products = ref<any[]>([])

  const compareCount = computed(() => products.value.length)
  const isInCompare = computed(() => {
    return (id: string) => products.value.some(p => p.id === id)
  })

  function toggleCompare(product: any) {
    if (!product || !product.id) return

    const index = products.value.findIndex(p => p.id === product.id)

    if (index === -1) {
      products.value.push(product)

      if (products.value.length > 4) {
        products.value.shift()
      }
    } else {
      products.value.splice(index, 1)
    }
  }

  function setProducts(newProducts: any[]) {
    products.value = newProducts
  }

  function removeById(id: string) {
    const index = products.value.findIndex(p => p.id === id)
    if (index !== -1) {
      products.value.splice(index, 1)
    }
  }

  return {
    products,
    compareCount,
    isInCompare,
    toggleCompare,
    setProducts,
    removeById,
  }
})
